import React, { useEffect, useRef, useState } from 'react';
import api from './../../services/api';
import {
  Container,
  Title,
  SubTitle,
  Description,
  ContainerText,
  ContainerTitle,
  ContainerImage,
  CarouselImage,
  Row,
} from './styles';
import { get, isEmpty } from 'lodash';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircle, faGlobe } from '@fortawesome/free-solid-svg-icons';

export const AboutCompany = ({ primaryColor, query, company }) => {
  const [currentImage, setCurrentImage] = useState(0);
  const [about, setAbout] = useState({});

  useEffect(() => {
    async function load() {
      const { label, page_label } = query;

      const aboutUrl =
        label && page_label
          ? `pages/sections/about/get/${label}/${page_label}`
          : `pages/sections/about/get/${label}`;

      try {
        const { data } = await api.get(aboutUrl);

        // Verificação de segurança para evitar erros quando data.data é undefined
        if (data && data.data) {
          setAbout(data.data);
        } else {
          console.warn('API response data structure is invalid in AboutCompany component:', data);
          setAbout({});
        }
      } catch (error) {
        console.error('Error loading about company info:', error);
        setAbout({});
      }
    }

    let isMounted = true;

    if (isMounted && query) {
      load();
    }

    return () => {
      isMounted = false;
    };
  }, [query]);

  const widthImg = index => {
    if (about?.qnt_images === 3) {
      if (index === 2) {
        return '100%';
      }
      return 'calc(50% - 22px)';
    }
    if (about?.qnt_images === 2) {
      return 'calc(50% - 22px)';
    }
    return '100%';
  };

  const maxWidthImg = index => {
    if (about?.qnt_images === 3) {
      if (index === 2) {
        return '100%';
      }
      return '460px';
    }
    if (about?.qnt_images === 2) {
      return 'calc(50% - 22px)';
    }
    return '100%';
  };

  useEffect(() => {
    if (about?.qnt_images > 0 && about?.images?.length > 0) {
      let pressed = false;
      let startX;
      let x;
      const totalItem = about?.qnt_images;
      const sliderContainer = document.querySelector('.container-slider-about');
      const innerSlider = document.querySelector('.inner-slider-about');

      sliderContainer.addEventListener('touchstart', e => {
        pressed = true;
        const touches = e.touches || e.originalEvent.touches;
        startX = touches[0].clientX - innerSlider.offsetLeft;
      });

      sliderContainer.addEventListener('touchend', e => {
        pressed = false;
      });

      sliderContainer.addEventListener('touchmove', e => {
        if (!pressed) return;
        e.preventDefault();
        const touches = e.touches || e.originalEvent.touches;
        x = touches[0].clientX;
        innerSlider.style.left = `${x - startX}px`;
        const total = Math.trunc(((x - startX) * -1) / 238.51);
        if (total > 0 && total <= totalItem) {
          setCurrentImage(total);
        } else if (total <= 0) {
          setCurrentImage(0);
        }
        setTimeout(() => {
          if (x - startX >= 0) {
            innerSlider.style.left = `12px`;
            setCurrentImage(0);
          }
          if (-totalItem * 238.51 > x - startX) {
            innerSlider.style.left = `${-totalItem * 238.51}px`;
            setCurrentImage(totalItem - 1);
          }
        }, 600);
      });
    }
  }, [about]);

  return (
    <Container
      id="about"
      primaryColor={primaryColor}
      actived={company?.custom_visible === 1 || about?.active}
    >
      <ContainerText>
        <ContainerTitle>
          <Title>
            {about?.title ||
              company?.custom_label ||
              `Por que a ${about?.title || company?.name}?`}
          </Title>
          { !isEmpty(about?.sub_title) && about?.sub_title !== 'null' ? (
            <>
              <SubTitle>{about?.sub_title}</SubTitle>
            </>
          ): null}
        </ContainerTitle>
        <Description>{about?.description || company?.custom_value}</Description>
      </ContainerText>
      {about?.qnt_images > 0 && about?.images?.length > 0 ? (
        <>
          <ContainerImage>
            {about?.images?.map(
              (img, index) =>
                index + 1 <= about?.qnt_images && (
                  <img
                    key={index}
                    className="img-about"
                    src={img.url}
                    alt={`Image ${index + 1}`}
                    style={{
                      width: widthImg(index) + ' !important',
                      maxWidth: maxWidthImg(index),
                    }}
                  />
                )
            )}
          </ContainerImage>
          <CarouselImage className="container-image">
            <div className="container-slider-about">
              <div className="inner-slider-about">
                {about?.images.map(
                  (image, index) =>
                    index + 1 <= about?.qnt_images && (
                      <img key={index} src={image.url} alt={`Image ${index + 1}`} />
                    )
                )}
              </div>
            </div>
          </CarouselImage>
          <Row style={{ marginTop: '26px' }} hide={about?.qnt_images === 1}>
            {about?.images?.map(
              (el, index) =>
                index + 1 <= about?.qnt_images && (
                  <FontAwesomeIcon
                    key={index}
                    onClick={() => setCurrentImage(index)}
                    style={{ cursor: 'pointer' }}
                    icon={faCircle}
                    color={
                      index === currentImage
                        ? primaryColor || '#403294'
                        : '#C0B6F2'
                    }
                  />
                )
            )}
          </Row>
        </>
      ) : (
        <>
          <br />
          <br />
        </>
      )}
      {/* <div
        style={{
          width: '100%',
          padding: '60px 0',
          display: 'flex',
          flexDirection: 'column-reverse',
          justifyContent: 'center',
          alignItems: 'center',
          gap: '16px',
        }}
      >
        <Description>Para saber mais sobre a nossa empresa</Description>
        <a href={company?.url}>
          <FontAwesomeIcon icon={faGlobe} color="#FFF" />{' '}
          <span style={{ color: '#FFF' }}>Acesse o nosso site</span>
        </a>
      </div> */}
    </Container>
  );
};
